<!--
  Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (permission()) {
<div class="release-schedule-container">
    <div class="page-header">
        <h2>Release Scheduling</h2>
        <p class="page-subtitle">
            Schedule planned downtime notices, then manually start and finish release messaging.
        </p>
    </div>

    @if (!showCreateReleaseSection()) {
    <div class="active-release-card">
        <h3>Active Release</h3>
        <p>
            {{ activeReleaseForDisplay()?.releaseDateStr }} at
            {{ formatDisplayTime(activeReleaseForDisplay()?.releaseTimeStr) }}
            {{ activeReleaseForDisplay()?.displayTimezone }}
        </p>
        <small>Use the action button in the grid below for this active release.</small>
    </div>
    }

    @if (showCreateReleaseSection()) {
    <div class="form-card">
        <div class="schedule-form">
            <label>
                Date
                <input class="form-input" type="date" [(ngModel)]="releaseDate"/>
            </label>
            <label>
                Time
                <input class="form-input" type="time" [(ngModel)]="releaseTime"/>
            </label>
            <label>
                Time Zone Label
                <input class="form-input" type="text" [(ngModel)]="displayTimezone" maxlength="20" placeholder="EST"/>
            </label>
            <label>
                Notice Days
                <input class="form-input" type="number" [(ngModel)]="noticeDays" min="0"/>
            </label>
            <div class="action-cell">
                <p-button class="gm-btn-primary" type="button" (click)="createSchedule()" [disabled]="loading">
                    Create Release
                </p-button>
            </div>
        </div>
    </div>
    }

    <p-table [value]="schedules"
             [loading]="loading"
             [stripedRows]="true"
             [showGridlines]="true"
             [tableStyle]="{'min-width': '60rem'}"
             class="release-table">
        <ng-template pTemplate="header">
            <tr>
                <th>Actions</th>
                <th>Release Date</th>
                <th>Release Time</th>
                <th>Timezone</th>
                <th>Notice Days</th>
                <th>Created By</th>
                <th>Created Date</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td class="actions-col">
                    @if (canShowStart(row)) {
                        <p-button type="button" (click)="startRelease(row)" class="mr-2">
                            Start Release
                        </p-button>
                    }
                    @if (canShowCancel(row)) {
                        <p-button type="button" (click)="cancelRelease(row)" severity="warn">
                            Cancel Release
                        </p-button>
                    }
                    @if (canShowFinish(row)) {
                        <p-button type="button" (click)="finishRelease(row)">
                            Finish Release
                        </p-button>
                    }
                </td>
                <td>{{ row.releaseDateStr }}</td>
                <td>{{ formatDisplayTime(row.releaseTimeStr) }}</td>
                <td>{{ row.displayTimezone }}</td>
                <td>{{ row.noticeDays }}</td>
                <td>{{ row.Created_By }}</td>
                <td>{{ row.Created_Date | date: 'medium'}}</td>
                <td>
                    <p-tag [value]="row.status" [severity]="getStatusSeverity(row.status)"></p-tag>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="empty-message">No releases scheduled yet.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
}
